import React from 'react';
import { connect } from 'react-redux';
import DatasetWizardActions from '../components/DatasetWizardActions';
import FullDatasetActions from './FullDatasetActions';
import { resolveCatalogueTemplate } from '../catalogue/helper';
import { datasetSourceAndStepAttributes, isDatasetWizardOn } from '../state/state';
import { checkDatasetIsNew, datasetIsEditing } from '../helper';

const DatasetActions = ({
  category,
  code,
  isEditing,
  isNew,
  wizardOn,
}) => (
  <>
    {(wizardOn || isNew) && (
    <DatasetWizardActions
      allowSave={!wizardOn}
      category={category}
      code={code}
      isEditing={isEditing}
    />
    )}
    {!wizardOn && !isNew && (<FullDatasetActions category={category} code={code} />)}
  </>
);

const mapStateToProps = ({
  auth: { role },
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { dataset, exists } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    asViewer: { on: false },
    isEditing: false,
    isNew: false,
    steps: datasetSourceAndStepAttributes(),
  });

  return ({
    ...checkDatasetIsNew(dataset, exists, ownProps.url),
    isEditing: datasetIsEditing(dataset),
    wizardOn: isDatasetWizardOn(dataset, role),
  });
};

export default connect(mapStateToProps)(DatasetActions);
